import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiEndpoints } from "../../services/apiConfig";

export const fetchPaymentHistory = createAsyncThunk(
  "userPayment/fetchPaymentHistory",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(apiEndpoints.fetchPaymentHistory, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const validateCouponCode = createAsyncThunk(
  "userPayment/validateCouponCode",
  async (payload, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(apiEndpoints.validateCoupon, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

const userPaymentSlice = createSlice({
  name: "userPayment",
  initialState: {
    data: [],
    validateCouponResponse: null,
    sendingSettings: {},
    domainCheck: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPaymentHistory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPaymentHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchPaymentHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(validateCouponCode.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(validateCouponCode.fulfilled, (state, action) => {
        state.loading = false;
        state.validateCouponResponse = action.payload;
      })
      .addCase(validateCouponCode.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default userPaymentSlice.reducer;
